import '../../../styles/Blog.css';
import {IMAGE_URL} from "../../../path";

type blogImage = {
    image_url: string;
}

function BlogImage(props: blogImage) {
    return (
        <div className="blog-single-image">
            <img src={`${IMAGE_URL}${props.image_url}`} className="blog-image" alt="blog-image" />
        </div>
    )
}

export default BlogImage;
